export default new class Burger {
   constructor() {
      this.burger = '.btn-burger'
      this.navMenu = '.mobile-menu'
      this.init()
   }

   init() {
      $(this.burger).on('click', ()=> {
         $(document).scrollTop(0)
         $(this.burger).toggleClass('active')
         $(this.navMenu).toggleClass('show')
         $('html').toggleClass('no-scroll')
      })
   }
}